import { useState } from "react";

import type { FilterDefinition } from "@/ds";

const CHAVE_OBRA = "obra";

/** Rótulo de toda obra já vista nas opções do filtro Obra: o chip não cai no GUID quando a obra sai das opções (troca de período ou de agrupamento). */
export function useRotulosDasObras(
  columns: readonly FilterDefinition[],
): ReadonlyMap<string, string> {
  const [vistos, setVistos] = useState<ReadonlyMap<string, string>>(() => new Map());
  const opcoes = columns.find(({ key }) => key === CHAVE_OBRA)?.options ?? [];
  // Por `value`, vale a última ocorrência: um valor repetido com rótulos diferentes não pode manter `novos` cheio.
  const ultimos = new Map(opcoes.map(({ value, label }) => [value, label] as const));
  const novos = [...ultimos].filter(([value, label]) => vistos.get(value) !== label);

  // Ajuste de estado durante o render (padrão do React): a referência só muda quando entra ou muda um rótulo.
  if (novos.length > 0) {
    setVistos(new Map([...vistos, ...novos]));
  }

  return vistos;
}
